module.exports = __webpack_public_path__ + "img/provider.df1f1ac9.svg";